<template>
  <img :src="src" class="brand-logo" />
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      required: true
    }
  }
};
</script>
